module.exports = __webpack_public_path__ + "static/media/رحلات تسوق في مختلف المدن السويسرية.42a2b718.jpeg";